import * as THREE from 'three';
import { solidworksDefaultPreset } from '../imported-model/render/solidworks-default-preset';
import type { SolidBodyDisplayMaterialRecipe } from './solid-body-display-material-recipe';

/**
 * 实体体网格材质工厂。
 *
 * 设计说明：
 * 1. 统一创建特征结果体与无导入参考时的默认实体主材质；
 * 2. 默认配方复用 `plasticColor + baseMetalness/baseRoughness`，与装配体编辑态及典型 SW 塑料件一致；
 * 3. 特征结果体固定 `DoubleSide`，以满足 CAD 薄壁/开放壳体的可见性要求。
 */
export class SolidBodyMeshMaterialFactory {
  /**
   * 读取无导入参考时的默认实体显示配方。
   *
   * @returns 默认实体材质配方。
   */
  public static getDefaultRecipe(): SolidBodyDisplayMaterialRecipe {
    return {
      color: solidworksDefaultPreset.material.plasticColor,
      metalness: solidworksDefaultPreset.material.baseMetalness,
      roughness: solidworksDefaultPreset.material.baseRoughness,
    };
  }

  /**
   * 按配方创建实体主材质。
   *
   * @param recipe 可选材质配方；缺省时使用 {@link getDefaultRecipe}。
   * @returns 新建的 MeshStandardMaterial 实例。
   */
  public static createSolidBodyMaterial(
    recipe: SolidBodyDisplayMaterialRecipe = SolidBodyMeshMaterialFactory.getDefaultRecipe(),
  ): THREE.MeshStandardMaterial {
    return new THREE.MeshStandardMaterial({
      color: recipe.color,
      metalness: recipe.metalness,
      roughness: recipe.roughness,
      side: THREE.DoubleSide,
    });
  }
}
